import { TextsType } from '../types'
const sections = [
  { url: 'domu', name: 'Domů' },
  { url: 'projekty', name: 'Projekty' },
  { url: 'cv', name: 'CV' },
]
const texts: TextsType = {
  title: 'Jakub Sirotek',
  sections: sections,
  name: 'Jakub Sirotek',
  switcher: ['Web', 'Zájmy'],
  introduction: [
    'Jakub Sirotek',
    <>
      Jsem <span>front-end developer</span> a <span>designer</span>. Tvořím
      moderní webové aplikace především pomocí <span>Reactu</span>,{' '}
      <span>TypeScriptu</span> a <span>Next.js</span>. Primárně používám{' '}
      <span>Cursor</span>, jako doplněk <span>ChatGPT</span>. Díky zkušenostem s
      grafikou a designem se zaměřuji nejen na kvalitní kód, ale také na vzhled,
      interakci a uživatelský zážitek.
    </>,
    <>
      V <span>Reactu</span> pracuji od roku 2022, v roce 2026 jsem své
      zkušenosti obohatil o <span>Next.js</span>. Mám zkušenosti také s{' '}
      <span>Tailwind CSS</span>, <span>styled-components</span>,{' '}
      <span>Prisma</span>, <span>PostgreSQL</span> a <span>Vercel</span> a
      postupně rozšiřuji své zaměření směrem k full-stack vývoji.
    </>,
    'Dříve jsem používal především vanilla JavaScript a různé JS knihovny podle potřeby. V rámci grafiky jsem pracoval i s 3D grafikou a animacemi.',
    'Rád pracuji v týmu, učím se nové věci a prohlubuji stávájící dovednosti.',
  ],
  skills: ['Front-end', 'Design', '3D, post effects', 'Učím se'],
  otherprojects: 'Starší projekty',
  contacts: {
    title: 'Kontakty',
    email: ['email:', 'sirotek.j@gmail.com'],
    linkedin: [
      'LinkedIn:',
      'https://www.linkedin.com/in/jakub-sirotek-1bb0364a/',
    ],
  },
  eriwen: {
    name: 'Eriwen',
    link: 'https://www.eriwen.cz/',
    type: 'web site',
    year: '2026',
    technics: [
      'NextJS',
      'typescript',
      'tailwind',
      'NextAuth',
      'REST API',
      'github',
      'vercel',
      'prisma',
    ],
    aspectRatio: '16/9',
    preview: 'images/web/eriwen/eriwenpreview.jpg',
    imgs: [
      'images/web/eriwen/eriwen1.jpg',
      'images/web/eriwen/eriwen2.jpg',
      'images/web/eriwen/eriwen3.jpg',
      'images/web/eriwen/eriwen4.jpg',
    ],
    intro:
      'Stránky skupiny přátel hrající dračí doupě na sdílení informací - postav, příběhů, map, prostředí atd.',
    texts: [
      <>
        <p>
          Pro tento projekt jsem zvolil pro mně nový stack s <span>NextJS</span>{' '}
          a <span>typescriptem</span>. Vybral jsem tak i proto, že jsem
          procházel <span>NextJS</span> kurzem a tím bylo učení intenzivnější i
          kreativnější. Zároveň za pomocí ChatGPT byla práce rychlejší a v
          neznámějších vodách jasnější.
        </p>
        <p>
          Celý kód je na <span>githubu</span> a builduje se ve{' '}
          <span>Vercelu</span>.
        </p>
      </>,
      <>
        Na přihlašování jsem zvolil <span>NextAuth</span>, kde se každý člen
        může přihlásit pomocí svého emailového účtu.
      </>,
      <>
        <p>
          Databáze Neon pak běží na Vercelu, kde se nachází i blob na ukládání
          obrázků. V NextJS používám novější Server Actions a Prismu. Ve
          formulářích jsem taky použil Jodit Rich text editor.
        </p>
        <p>
          Tady jsem také řešil různé typy řazení údajů v databázi pro různé
          případy příspěvků. Od řazení podle order a vkládání mezi ně, přes
          hierarchické řazení lokalit až po speciální kalendář, kde se dá
          vkládat jak rok, tak datum, měsíc nebo roční období.
        </p>
      </>,
    ],
  },
  voicesofthebrave: {
    name: 'Voices of the Brave',
    link: 'https://www.currenttime.tv/a/voices-of-the-brave/33441095.html',
    type: 'microsite',
    year: '2025',
    technics: ['React', 'datawrapper', 'swiper'],
    aspectRatio: '8/5',
    preview: 'images/web/voicesofthebrave/voicesofthebravepreview.jpg',
    imgs: [
      'videos/web/voicesofthebrave/voicesofthebravevideo1.mp4',
      'images/web/voicesofthebrave/voicesofthebrave2.jpg',
      'images/web/voicesofthebrave/voicesofthebrave3.jpg',
      'videos/web/voicesofthebrave/voicesofthebravevideo2.mp4',
    ],
    intro:
      'Microsita o domácím násilí. Obsahuje 5 kapitol s jednotlivými příběhy. Je založena na originálních ilustracích, které jsou v každé kapitole použity různými způsoby.',
    texts: [
      'Každá kapitola začíná animací, která je vytvořena z původní ilustrace. Na animacích bylo náročné pozicování animovaných objektů, kde musely mít pro různá rozlišení jiné rozměry a pozice.',
      'Součástí stránek jsou části ilustrací s parallax efektem.',
      <>
        Pro několik grafů a map jsme vybrali <span>datawrapper</span>, kvůli
        jednoduchosti, aby je mohli vyplňovat také editoři.
      </>,
      'Ukázka jedné ze šesti hlavních animací na začátku každé z kapitol.',
    ],
  },
  soldierswhodiedinukraine: {
    name: 'Soldiers Who Died in Ukraine',
    type: 'Microsite',
    year: '2022',
    link: 'https://www.azatliq.org/a/sugishta-ulucheler/31916561.html',
    technics: ['React', 'react-router-dom', 'framer-motion'],
    aspectRatio: '8/5',
    preview:
      'images/web/soldierswhodiedinukraine/soldierswhodiedinukrainepreview.jpg',
    imgs: [
      'images/web/soldierswhodiedinukraine/soldierswhodiedinukraine1.jpg',
      'images/web/soldierswhodiedinukraine/soldierswhodiedinukraine2.jpg',
      'images/web/soldierswhodiedinukraine/soldierswhodiedinukraine3.jpg',
      'images/web/soldierswhodiedinukraine/soldierswhodiedinukraine4.jpg',
      'images/web/soldierswhodiedinukraine/soldierswhodiedinukraine5.jpg',
    ],
    intro:
      'Stránka věnovaná obětem války na Ukrajině z Tatarstánu a Baškortostánu.',
    texts: [
      <>
        Infografika vytvořená v <span>Reactu</span>. Na úvodní obrazovce je
        carousel s několika vybranými fotkami a základní informace o grafice.
      </>,
      <>
        V další části můžete vidět mapu. Je možné ji přepínat mezi dvěma
        regiony. Do mapy se načítají data z dokumentu na Google Disku pomocí
        API. Jednotlivé části mapy se zbarvují podle počtů padlých.
      </>,
      'V hlavní části jsou seznamy padlých. Aby nebylo skrolování příliš dlouhé, je použité stránkování. Lazy load by mohl způsobit, že by čtenářům trvalo skrolování příliš dlouho.',
      <>
        V hlavní části jsem použil také filtry, které jsou vícestupňové, z
        důvodu velkého počtu padlých. Dá se filtrovat pomocí regionu, věku,
        hodnosti atd.
      </>,
      'Každý člověk má stránku s vlastním id, která se dá zvlášť sdílet. Pod kartou s údaji se objevují opět seznamy, které mají použitý stejný typ filtrování.',
    ],
  },
  ukraineweapons: {
    name: 'Ukrainian Weapons',
    link: 'https://www.svoboda.org/a/legendarnoe-oruzhie-ukrainy/32284978.html',
    technics: ['Svelte', 'swiper', 'gsap'],
    type: 'microsite',
    year: '2023-2024',
    aspectRatio: '128/73',
    preview: 'images/web/ukraineweapons/ukraineweaponspreview.jpg',
    imgs: [
      'images/web/ukraineweapons/ukraineweapons1.jpg',
      'videos/web/ukraineweapons/ukraineweaponsvideo.mp4',
      'images/web/ukraineweapons/ukraineweapons3.jpg',
      'images/web/ukraineweapons/ukraineweapons4.jpg',
      'images/web/ukraineweapons/ukraineweapons5.jpg',
      'images/web/ukraineweapons/ukraineweapons6.jpg',
    ],
    intro:
      'Projekt napsaný ve Svelte frameworku, který pojednává o používání vybraných moderních zbraní ve válce na Ukrajině. Moje část práce byla funkčnost a implementace kódu.',

    texts: [
      'Projekt byl  dlouhodobý. Byl rozdělen do 4 kapitol, které jsme postupně vydávali a doplňovali během let 2023-24.',
      'Hlavní část každé kapitoly je prezentace zbraně, kde je animace ovládána scrollováním, která se v konkrétních chvílích zastaví a zobrazí se popisy.',
      'Komplikovaná část projektu byla responsivita layoutu kvůli animacím a videím s popisky. Výraznější rozdíly musely být použity v mobilní verzi.',
      'V celém projektu bylo velké množství interaktivních prvků.',
      'Animace byly často spouštěny při skrolování, nebo byly na skrolování přímo napojeny.',
      <>
        Projekt byl také zkouškou frameworku <span>Svelte</span>, aby tým
        zjistil, jestli se mu věnovat dál nebo radši používat React.
      </>,
    ],
  },
  ctcatalogue: {
    name: 'Current Time Catalog',
    type: 'microsite',
    year: '2022',
    link: 'https://www.currenttime.tv/a/28791461.html',
    technics: ['React', 'react-router-dom', 'framer-motion', 'swiper'],
    aspectRatio: '8/5',
    preview: 'images/web/ctcatalogue/ctcataloguepreview.jpg',
    imgs: [
      'videos/web/ctcatalogue/ctcatalogueVideo2.mp4',
      'videos/web/ctcatalogue/ctcatalogueVideo1.mp4',
      'images/web/ctcatalogue/ctcatalogue.jpg',
    ],
    intro: (
      <>
        CT Catalog je stránka s popisy několika desítek vybraných programů na
        televizi Current Time. Moje část práce byla vytvořit na základě designu
        funkční stránku v <span>Reactu</span>.
      </>
    ),
    texts: [
      <>
        Tento projekt byl první, který jsem celý vytvořil v <span>Reactu</span>.
        Vybral jsem ho proto, že se stránka skládá z přehledu programů televize
        Current Time, které spadají do různých kategorií. A díky filtraci
        kategorií je potřeba, aby se stránka přizpůsobovala.
      </>,
      'Dlaždicový systém umožnil snadné řešení designu na menších zařízeních.',
      <>
        Je zde použit <span>react-router-dom</span> na orientaci v rámci
        stránek, <span>framer motion</span> na některé animace a{' '}
        <span>swiper</span> na jednodušší přepínání mezi detaily jednotlivých
        programů.
      </>,
    ],
  },
  web: [
    {
      name: 'Timeline Ukraine War',
      type: 'Microsite',
      year: '2025',
      technics: ['React'],
      aspectRatio: '16/9',
      preview: 'images/web/timelineukrainewar/timelineukrainewar1_m.jpg',
      imgs: [
        'images/web/timelineukrainewar/timelineukrainewar1.jpg',
        'images/web/timelineukrainewar/timelineukrainewar2.jpg',
        'images/web/timelineukrainewar/timelineukrainewar3.jpg',
      ],
      link: 'https://www.radiosvoboda.org/a/istoriya-viyny-rosiya-ukraina/32831284.html',
      intro: (
        <>
          Časová osa s nejdůležitějšími událostmi v posledních 10 letech.
          Grafika je vytvořena v <span>Reactu</span>.
        </>
      ),
      texts: [],
    },
    {
      name: 'Srebrenica Anniversary',
      type: 'Microsite',
      year: '2022',
      technics: ['HTML', 'CSS', 'JavaScript'],
      aspectRatio: '16/9',
      preview: 'images/web/srebrenicaanniversary/srebrenicaanniversary1_m.jpg',
      imgs: [
        'images/web/srebrenicaanniversary/srebrenicaanniversary2.jpg',
        'videos/web/srebrenicaanniversary/srebrenicaanniversaryvideo1.mp4',
        'images/web/srebrenicaanniversary/srebrenicaanniversary3.jpg',
      ],
      link: 'https://www.slobodnaevropa.org/a/srebrenica-dokumentovani-genocid/30713005.html',
      intro:
        'Infografika k výročí genocidy v Srebrenici. Vzhledem k vcelku jednoduchému ovládání jsem zvolil pouze vanilla javascript.',
      texts: [
        'Společně s designerem projektu jsme spolupracovali na unikátním ovládání pomocí otáčející se květiny jako menu a stránkování.',
        'Důležité bylo uspořádat všechny prvky layoutu na různých zařízeních. To zajišťovalo částečně CSS, částečně JavaScript.',
      ],
    },
    {
      name: 'Constitution is difficult in Kazakh',
      type: 'Microsite',
      year: '2022',
      technics: ['HTML', 'css', 'JavaScript', 'swiper'],
      aspectRatio: '16/9',
      preview: 'images/web/kazakhconstitution/kazakhconstitution1_m.jpg',
      imgs: [
        'images/web/kazakhconstitution/kazakhconstitution1.jpg',
        'images/web/kazakhconstitution/kazakhconstitution2.jpg',
      ],
      link: 'https://www.idelreal.org/a/31569821.html',
      intro: <>Grafika o nedostatcích v kazašské ústavě.</>,
      texts: [
        <>
          Celá grafika je vytvořena ve vanilla js s použitím jedné js knihovny:{' '}
          <span>swiper</span>.
        </>,
      ],
    },
    /*{
      name: 'Chamber 319',
      type: 'Microsite',
      year: '2021',
      technics: ['HTML', 'css', 'JavaScript', 'grunt'],
      aspectRatio: '16/9',
      preview: 'images/Chamber.png',
      imgs: ['images/Chamber.png'],
      link: 'https://www.idelreal.org/a/31569821.html',
      intro: (
        <>
          Grafika o násilí při vyslýchání ve vězení v Tatarstánu. Microsite byla
          vytvořena za pomoci <span>Grunt</span> task runner na minifikaci
          javascriptu a sass.
        </>
      ),
      texts: [],
    },*/
    {
      name: 'US Election 2020',
      type: 'Grafika',
      year: '2020',
      technics: ['HTML', 'javascript', 'css', 'underscore'],
      aspectRatio: '16/9',
      link: 'https://www.currenttime.tv/a/elections-us-2020/30926082.html',
      preview: 'images/web/uselections/uselectionspreview.jpg',
      imgs: [
        'images/web/uselections/uselections1.jpg',
        'images/web/uselections/uselections2.jpg',
      ],
      intro: 'Grafika o výsledcích voleb USA v roce 2020.',
      texts: [
        'Stránka byla publikována ve více jak 10 jazycích. K tomu sloužil google sheet, ve kterém mohli editoři vyplnit potřebné překlady.',
        <>
          Obsah se načítal s Google tabulky vytvořené pro editory. Pomocí js
          knihovny <span>underscore</span> byly jednotlivé části dynamicky
          vykreslované na základě dat.
        </>,
      ],
    },
    {
      name: 'The Tragedy of the Kursk',
      type: 'Microsite',
      year: '2015',
      technics: ['HTML', 'CSS', 'JavaScript'],
      aspectRatio: '16/9',
      link: 'https://www.rferl.org/a/kursk-russia-submarine-disaster/27183289.html',
      preview: 'images/web/kursk/kursk1_s.jpg',
      imgs: [
        'images/web/kursk/kursk1.jpg',
        'images/web/kursk/kursk2.jpg',
        'images/web/kursk/kursk6.jpg',
        'images/web/kursk/kursk5.jpg',
      ],
      intro: 'Infografika k výročí potopení ponorky Kursk.',
      texts: [
        'Pracoval jsem v týmu s 3D grafikem. Základem byly animace jako sekvence snímků rozpohybované javascriptem.',
        'Animace se zastavovala na specifických místech, kde byly doplněny popisky.',
        'Pro mobilní telefony jsme kvůli širokoúhlému designu nechali místo animací a interaktivity statické obrázky s popisky. Grafika byla připravena ve více jazycích.',
      ],
    },
  ],
  others: [
    {
      name: 'STEP',
      type: 'flash',
      preview: 'images/3d/step/stepvodikovaekonomika_s.jpg',
      imgs: [
        'images/3d/step/stepvodikovaEkonomika.jpg',
        'images/3d/step/steptechnologiepiva.jpg',
        'images/3d/step/stepperiodickatabulka.jpg',
        'images/3d/step/stepchemickyrobot.jpg',
        'images/3d/step/stepcisteniodpadnichvod.jpg',
        'images/3d/step/stepfotokatalyza.jpg',
      ],
      year: '2013 - 2014',
      link: 'https://step.vscht.cz/infografiky/vodikova-ekonomika/',
      technics: ['Flash', 'Cinema 4D'],
      aspectRatio: '16/9',
      intro: 'Vizualizace vybraných témat pro VŠCHT.',
      texts: [
        <a
          href="https://step.vscht.cz/infografiky/vodikova-ekonomika/"
          target="_blank"
          rel="noreferrer noopener"
        >
          https://step.vscht.cz/infografiky/vodikova-ekonomika/
        </a>,
        <a
          href="https://step.vscht.cz/infografiky/vyroba-piva/"
          target="_blank"
          rel="noreferrer noopener"
        >
          https://step.vscht.cz/infografiky/vyroba-piva/
        </a>,
        <a
          href="https://step.vscht.cz/infografiky/periodicka-tabulka-prvku/"
          target="_blank"
          rel="noreferrer noopener"
        >
          https://step.vscht.cz/infografiky/periodicka-tabulka-prvku/
        </a>,
        <a
          href="https://step.vscht.cz/infografiky/chemicky-robot/"
          target="_blank"
          rel="noreferrer noopener"
        >
          https://step.vscht.cz/infografiky/chemicky-robot/
        </a>,
        <a
          href="https://step.vscht.cz/infografiky/odpadni-vody/"
          target="_blank"
          rel="noreferrer noopener"
        >
          https://step.vscht.cz/infografiky/odpadni-vody/
        </a>,
        <a
          href="https://step.vscht.cz/infografiky/fotokatalyza/"
          target="_blank"
          rel="noreferrer noopener"
        >
          https://step.vscht.cz/infografiky/fotokatalyza/
        </a>,
      ],
    },
    {
      name: 'Svět objevů',
      type: 'Advertising',
      year: '2013',
      technics: ['Cinema 4D', 'After Effects'],
      aspectRatio: '16/9',
      link: 'https://www.youtube.com/watch?v=8R_hPwSHPyM',
      preview: 'images/3d/svetobjevu/svetobjevu1_s.jpg',
      imgs: [
        'images/3d/svetobjevu/svetobjevu1.jpg',
        'images/3d/svetobjevu/svetobjevu2.jpg',
        'images/3d/svetobjevu/svetobjevu3.jpg',
        'images/3d/svetobjevu/svetobjevu4.jpg',
        'images/3d/svetobjevu/svetobjevu5.jpg',
        'images/3d/svetobjevu/svetobjevu6.jpg',
        'images/3d/svetobjevu/svetobjevu7.jpg',
      ],
      intro:
        'Reklamní spot na časopis Svět objevů. Zde jsme dostali pdf všech stránek časopisu, a na nás bylo rozanimovat a doplnit zajímavými prvky.',
      texts: [''],
    },
  ],
  interests: [
    {
      name: 'Šmoula',
      type: 'LEGO',
      year: '2026',
      technics: ['BrickLink Studio'],
      aspectRatio: '1/1',
      link: '',
      preview: 'images/interests/lego/smoula.webp',
      imgs: [
        'images/interests/lego/smoula.webp',
        'images/interests/lego/medievil_house.webp',
      ],
      intro: 'Stavby z LEGA',
      texts: [
        'Model Šmouly, počet kostek: 1734',
        'Středověké stavení, počet kostek: 364',
      ],
    },
    {
      name: 'Fantasy věž',
      type: 'sculpting',
      year: '2026',
      technics: ['model'],
      aspectRatio: '3/4',
      link: '',
      preview: 'images/interests/tower/towerpreview.jpg',
      imgs: ['images/interests/tower/tower.jpg'],
      intro: 'Modelování miniatury věže z betonu.',
      texts: ['Miniatura fantasy věže'],
    },
    {
      name: 'Coloring minifigures',
      type: 'coloring',
      year: '2022-dnes',
      technics: ['coloring'],
      aspectRatio: '16/9',
      link: '',
      preview: 'images/interests/minifigures/minifigures1_m.jpg',
      imgs: [
        'images/interests/minifigures/minifigures1.jpg',
        'images/interests/minifigures/minifigures2.jpg',
        'images/interests/minifigures/minifigures3.jpg',
      ],
      intro: 'Barvení figurek z různých stolních her.',
      texts: ['Fallout', 'Fallout - Nová Kalifornie', 'Zaklínač'],
    },
    {
      name: 'MPR II',
      type: 'coloring',
      year: '2015-dnes',
      technics: ['model'],
      aspectRatio: '16/9',
      link: '',
      preview: 'images/interests/mpr/mpr1_m.jpg',
      imgs: ['images/interests/mpr/mpr1.jpg'],
      intro: 'Skoro hotový model Městské památkové rezervace z ABC.',
      texts: [],
    },
    {
      name: 'Desková hra',
      type: 'Design',
      year: '2020-?',
      technics: ['Adobe Illustrator'],
      aspectRatio: '16/9',
      link: '',
      preview: 'images/interests/dashboard/dashboard1_m.jpg',
      imgs: [
        'images/interests/dashboard/dashboard1.jpg',
        'images/interests/dashboard/dashboard2.jpg',
        'images/interests/dashboard/dashboard3.jpg',
      ],
      intro: 'Osobní projekt, kde jsem vymýšlel stolní hru.',
      texts: [
        <>
          Zde je pár karet a dalších návrhů. Ilustrace na kartách jsou jen
          provizorní. Ilustrace vpravo na kartách postav: Michal Sirotek.
        </>,
        'A tady je první verze hry, která byla pouze v ruce.',
      ],
    },
    {
      name: 'Model domu',
      type: '3D',
      preview: 'images/interests/dum_m.png',
      imgs: ['images/interests/dum.png'],
      year: '2014',
      link: '',
      technics: ['Cinema 4D'],
      aspectRatio: '304/215',
      intro: 'Vizualizace domu se zahradou a interiérem.',
      texts: [],
    },

    {
      preview: 'images/3d/kytara_s.jpg',
      imgs: ['images/3d/kytara_m.jpg'],
      name: 'Kytara',
      type: '',
      year: '2009',
      link: '',
      technics: ['Cinema 4D'],
      aspectRatio: '16/9',
      intro: '',
      texts: [],
    },
    {
      preview: 'images/3d/veteran1_s.jpg',
      imgs: ['images/3d/veteran1_m.jpg'],
      name: 'Veterán',
      type: '',
      year: '2009',
      link: '',
      technics: ['Cinema 4D'],
      aspectRatio: '16/9',
      intro: '',
      texts: [],
    },
  ],
  cv: {
    title: 'CV',
    education: 'Vzdělání',
    schools: [
      {
        title: 'Vyšší odborná škola Václava Hollara',
        subtitle: 'Diplomovaný specialista (DiS), Interaktivní grafika',
        years: '2006 - 2009',
      },
      {
        title: 'České vysoké učení technické v Praze',
        subtitle: 'Fakulta stavební',
        years: '2005 - 2006',
      },
      {
        title: 'Gymnázium Nad Štolou',
        subtitle: '',
        years: '1997 - 2005',
      },
    ],
    jobs: 'Pracovní zkušenosti',
    companies: [
      {
        title: 'Vlastní projekty, sebevzdělávání',
        logo: '',
        subtitle: 'Front-end Developer',
        description:
          'Po delší době jsem měl volnější ruce, tak jsem se pustil do učení nových věcí a vlastních projektů. Začal jsem kurzy NextJS, také jsem začal používat Tailwind na CSS a deployment na Vercelu.',
        years: 'únor 2026 - současnost',
      },
      {
        title: 'Radio Free Europe/Radio Liberty',
        logo: 'images/logos/rfeorange.png',
        subtitle: 'Data Visualization Designer, Front-end developer',
        description:
          'V rámci Pangei (vývoj redakčního systému pro RFE) vznikl nový tým zaměřený na tvorbu infografik a microsite. Zpočátku jsme se soustředili na rozvoj responzivních řešení pro vizuálně složitější animace a vizualizace. Postupně se tým rozrůstal a přešli jsme na technologie React, TypeScript a GitHub. Zde jsem prošel také změnou workflow – od online spolupráce až po GitFlow – v důsledku pandemie covidu.',
        years: 'říjen 2014 - leden 2026',
      },
      {
        title: 'newslab.cz',
        logo: 'images/logos/newslab.jpg',
        subtitle: 'Graphic Designer',
        description:
          'Tvorba vizuálního designu a animací pro zpravodajské a publicistické projekty. Spolupráce na interaktivních projektech – původně v Adobe Flash, postupný přechod na HTML5. Animace v Cinema 4D a After Effects.',
        years: 'říjen 2010 - září 2014',
      },
      {
        title: 'PPF Media',
        logo: 'images/logos/futuroom.jpg',
        subtitle: 'Graphic Designer',
        description:
          'Zde jsem pracoval v týmu, kde jsme vytvářeli interaktivní animované projekty v Adobe Flash. Na animace jsem využíval Cinema 4D a After Effects. Jednalo se především o zpravodajské události a zajímavosti.',
        years: 'říjen 2009 - září 2010',
      },
      {
        title: 'Karlova universita, 1. lékařská fakulta',
        logo: 'images/logos/cu.jpg',
        subtitle: 'Graphic Designer',
        description:
          'Práce spočívala ve tvorbě interaktivních animací určených pro výuku studentů lékařské fakulty, vytvářených převážně v Adobe Flash. Podílel jsem se na celém procesu – od návrhu a designu až po programování interaktivních částí.',
        /*description:
          'I work on some parts of project interactive infographics in Adobe Flash for students of First Faculty of Medicine on Charles University',*/
        years: '2007 - 2009',
      },
    ],
  },
}
export default texts
